import { Tooltip, Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Alert, Box } from '@superdispatch/ui-lab';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { LinkButton } from 'shared/routing/Links';
import styled from 'styled-components';

const DarkText = styled(Typography)`
  color: ${ColorDynamic.Dark500};
`;

const ButtonCenterText = styled(LinkButton)`
  text-align: center;
`;

interface BankDifferentBannerProps {
  title: string;
  description: string;
  buttonLabel: string;
  to: string;
  dismissStorageKey: string;
  dismissTag: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

export function BankDifferentBanner({
  title,
  description,
  buttonLabel,
  to,
  dismissStorageKey,
  dismissTag,
  disabled,
  disabledTooltip,
}: BankDifferentBannerProps) {
  const dismissedValue = useLocalStore(dismissStorageKey);
  const isDismissed = dismissedValue === dismissTag;

  if (isDismissed) {
    return null;
  }

  const button = (
    <ButtonCenterText
      size="small"
      variant="neutral"
      to={to}
      disabled={disabled}
    >
      {buttonLabel}
    </ButtonCenterText>
  );

  return (
    <Alert
      severity="info"
      onClose={() => {
        LocalStore.set(dismissStorageKey, dismissTag);
      }}
    >
      <Stack space="small">
        <Stack space="xxsmall">
          <DarkText variant="h5">{title}</DarkText>
          <DarkText>{description}</DarkText>
        </Stack>
        <Box>
          {disabled && disabledTooltip ? (
            <Tooltip
              title={disabledTooltip}
              enterTouchDelay={0}
              leaveTouchDelay={5000}
              arrow={true}
            >
              <Box display="inline-block">{button}</Box>
            </Tooltip>
          ) : (
            button
          )}
        </Box>
      </Stack>
    </Alert>
  );
}
